import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lg:grid grid-cols-4 items-strech divide-x-2 divide space-y-3 lg:space-y-0" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Ip")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Location")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Timezone")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Isp")

import { computed, PropType } from 'vue';

import ResponseBoxData from './ResponseBoxData.vue';
import { ApiResponse } from '@/types/types';


export default /*#__PURE__*/_defineComponent({
  props: {
  responseData: Object as PropType<ApiResponse>,
},
  setup(__props) {

const props = __props



const timezoneWithColon = computed(() => {
  const timezone = props.responseData?.timezone;

  return [
    timezone?.slice(0, timezone.length - 2),
    ':',
    timezone?.slice(timezone.length - 2),
  ].join('');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ResponseBoxData, null, {
      header: _withCtx(() => [
        _hoisted_2
      ]),
      data: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.responseData?.ip), 1)
      ]),
      _: 1
    }),
    _createVNode(ResponseBoxData, null, {
      header: _withCtx(() => [
        _hoisted_3
      ]),
      data: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.responseData?.city) + ", " + _toDisplayString(__props.responseData?.region) + " " + _toDisplayString(__props.responseData?.postalCode), 1)
      ]),
      _: 1
    }),
    _createVNode(ResponseBoxData, null, {
      header: _withCtx(() => [
        _hoisted_4
      ]),
      data: _withCtx(() => [
        _createTextVNode(" UTC " + _toDisplayString(_unref(timezoneWithColon)), 1)
      ]),
      _: 1
    }),
    _createVNode(ResponseBoxData, null, {
      header: _withCtx(() => [
        _hoisted_5
      ]),
      data: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.responseData?.isp), 1)
      ]),
      _: 1
    })
  ]))
}
}

})